module.exports = __webpack_public_path__ + "img/share-icon-black.e5dd1e8b.svg";